<div #content class="engineTable">
  <ng-content></ng-content>
</div>